import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    workUnitChannel = new Subject();
    EmployeeStatusChannel = new Subject();
    indexChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.indexChannel.next({status: apiResponse.INITIAL})
    }

    fetchWorkUnit = async (query) => {
        this.workUnitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchWorkUnit(query).then((result) => {
            this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchEmployeeStatus = async (query) => {
        this.EmployeeStatusChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchEmployeeStatus(query).then((result) => {
            this.EmployeeStatusChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.EmployeeStatusChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default IndexBloc